import {Paginazione} from "../../shared/models/paginazione";
import {DatePipe} from "@angular/common";
import {ClassicType} from "../../shared/models/ClassicType";

export class FiltriLavorazione extends Paginazione{
  datepipe = new DatePipe('it-it');
  stato:string;
  cliente: string;
  prodotto: string;
  orderByNome: 'asc' | 'desc' | undefined;
  orderByData: 'asc' | 'desc' | undefined;
  inizio: string;
  fine: string;
  periodo: boolean;
  materiale?: string[];
  colore?: string[];
  tipiClienteSelezionati: ClassicType[];
  tipi: any[];
  ordine?: string;

  constructor(stato?: string, cliente?: string, prodotto?: string, orderByNome?: 'asc' | 'desc', orderByData?: 'asc' | 'desc',inizio?: string | Date, fine?: string | Date, periodo?: boolean ) {
    super(undefined,undefined)
    const today = new Date();
    const inizioMese = new Date(today.getFullYear(), 0, 1);
    const fineMese = new Date(today.getFullYear(), today.getMonth() + 1, 0) ;
    this.stato = stato || "T";
    this.cliente = cliente;
    this.prodotto = prodotto;
    this.orderByNome = orderByNome;
    this.orderByData = orderByData;
    this.inizio = this.datepipe.transform(inizio || inizioMese,'yyyy-MM-dd');
    this.fine = this.datepipe.transform(fine || fineMese, 'yyyy-MM-dd');
    this.periodo = periodo ?? false;
    this.tipiClienteSelezionati = []
    this.tipi = []
  }
}
